define(
  'results',[
    'paramsObserver',
    'lazyLoad'
  ],
  (
    paramsObserver,
    lazyLoad
  ) => {
    'use strict';

    /**
     * @private
     * resultsLoading: handler results when the results are ready.
     *
     * @param {object} value with the results to set on HTML.
     */
    function resultsLoading(value) {
      const newResults = document.createElement('div');
      const resultList = document.getElementById('nhs_ResultList');
      newResults.innerHTML = value.data;
      resultList.innerHTML = newResults.querySelector('#nhs_ResultList').innerHTML;
      document.querySelector('[data-template-facet-community-name]').innerHTML =
      newResults.querySelector('[data-template-facet-community-name]').innerHTML;
      document.querySelector('[data-template-facet-builder-name]').innerHTML =
      newResults.querySelector('[data-template-facet-builder-name]').innerHTML;
    }

    function resultsLoaded() {
      lazyLoad.init();
    }

    resultsLoaded();
    paramsObserver.subscribe('resultsLoaded', resultsLoaded);
    paramsObserver.subscribe('resultsHandling', resultsLoading);
  }
);

